module.exports = __webpack_public_path__ + "img/terms-conditions.e21ad340.svg";